import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-4" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "row mb-2" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = { class: "row mb-2" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "col-4" }
const _hoisted_12 = { class: "row mb-2" }
const _hoisted_13 = { class: "col-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Subtitle = _resolveComponent("Subtitle")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_CssDimensionEditor = _resolveComponent("CssDimensionEditor")!
  const _component_MetadataGroupCard = _resolveComponent("MetadataGroupCard")!
  const _component_GenericComponentWrapper = _resolveComponent("GenericComponentWrapper")!

  return (_openBlock(), _createBlock(_component_GenericComponentWrapper, { componentUI: _ctx.componentUI }, {
    default: _withCtx(() => [
      _createVNode(_component_MetadataGroupCard, {
        title: _ctx.$t('cms.container'),
        enabled: _ctx.enabled,
        name: _ctx.name,
        errors: _ctx.errors,
        "onUpdate:enabled": _ctx.onEnabledChanged,
        onReset: _ctx.resetToPersisted
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('cms.imageWidthPercentage'),
                mb: "2"
              }, null, 8, ["title"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_InputNumber, {
                    modelValue: _ctx.widthPercentage,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.widthPercentage) = $event)),
                      _ctx.emitModelChanged
                    ],
                    name: `${_ctx.name} ${_ctx.$t('cms.imageWidthPercentage')}`,
                    mode: "group-end",
                    "addon-text": "%",
                    min: 0,
                    max: 100,
                    rules: `min_value:${_ctx.MIN_WIDTH_PERCENTAGE}|max_value:100`,
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "name", "rules", "errors", "onUpdate:modelValue"])
                ])
              ]),
              (_ctx.showAlignment)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_Subtitle, {
                      title: _ctx.$t('cms.horizontalAlignment'),
                      mb: "2"
                    }, null, 8, ["title"]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_InputSelect, {
                          modelValue: _ctx.localDto.alignment_code,
                          "onUpdate:modelValue": [
                            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localDto.alignment_code) = $event)),
                            _ctx.emitModelChanged
                          ],
                          options: _ctx.enumPositionHorizontal,
                          name: `${_ctx.name} ${_ctx.$t('cms.horizontalAlignment')}`,
                          label: _ctx.$t('cms.horizontalAlignment'),
                          selectText: _ctx.$t('selectText'),
                          errors: _ctx.errors
                        }, null, 8, ["modelValue", "options", "name", "label", "selectText", "errors", "onUpdate:modelValue"])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('cms.imageAspectRatio'),
                mb: "2"
              }, null, 8, ["title"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_InputNumber, {
                    modelValue: _ctx.aspectRatioWidth,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.aspectRatioWidth) = $event)),
                      _ctx.emitModelChanged
                    ],
                    name: `${_ctx.name} ${_ctx.$t('cms.aspectRatioWidth')}`,
                    label: _ctx.$t('width'),
                    placeholder: _ctx.$t('cms.auto'),
                    min: 1,
                    rules: _ctx.aspectRatioWidthRules,
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "name", "label", "placeholder", "rules", "errors", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_InputNumber, {
                    modelValue: _ctx.aspectRatioHeight,
                    "onUpdate:modelValue": [
                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.aspectRatioHeight) = $event)),
                      _ctx.emitModelChanged
                    ],
                    name: `${_ctx.name} ${_ctx.$t('cms.aspectRatioHeight')}`,
                    label: _ctx.$t('height'),
                    placeholder: _ctx.$t('cms.auto'),
                    min: 1,
                    rules: _ctx.aspectRatioHeightRules,
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "name", "label", "placeholder", "rules", "errors", "onUpdate:modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Subtitle, {
                title: _ctx.$t('cms.imageMaxHeight'),
                mb: "2"
              }, null, 8, ["title"]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_CssDimensionEditor, {
                    modelValue: _ctx.localDto.max_height,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localDto.max_height) = $event)),
                      _ctx.emitModelChanged
                    ],
                    name: `${_ctx.name} ${_ctx.$t('cms.imageMaxHeight')}`,
                    min: 0,
                    allowDisable: false,
                    allowEmptyValue: true,
                    placeholder: _ctx.$t('none'),
                    errors: _ctx.errors
                  }, null, 8, ["modelValue", "name", "placeholder", "errors", "onUpdate:modelValue"])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["title", "enabled", "name", "errors", "onUpdate:enabled", "onReset"])
    ]),
    _: 1
  }, 8, ["componentUI"]))
}